import {ref} from 'vue';

export type EditorDialogPromptSaveCallback = (newVal: string | null) => void;
export interface EditorDialogPromptShowOptions {
	title: string;
	defaultValue: string;
	confirmLabel: string;
	multiline?: boolean;
}

export class EditorDialogPromptStoreControllerClass {
	private static _instance: EditorDialogPromptStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogPromptStoreControllerClass());
	}

	private _displayed = ref(false);
	private _title = ref('Prompt');
	private _multiline = ref(false);
	private _defaultValue = ref('');
	private _confirmLabel = ref('ok');
	private _on_save_callback: EditorDialogPromptSaveCallback | undefined;
	private constructor() {}

	// getters
	displayed(): boolean {
		return this._displayed.value;
	}
	title(): string {
		return this._title.value;
	}
	multiline(): boolean {
		return this._multiline.value;
	}
	defaultValue(): string {
		return this._defaultValue.value;
	}
	confirmLabel(): string {
		return this._confirmLabel.value;
	}
	executeOnSaveCallback(value: string | null) {
		if (value) {
			this._defaultValue.value = value;
		}
		if (this._on_save_callback) {
			const callback = this._on_save_callback;
			this._on_save_callback = undefined;
			callback(value);
		}
	}

	// mutations
	async show(options: EditorDialogPromptShowOptions): Promise<string | null> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._title.value = options.title;
			this._multiline.value = options.multiline || false;
			this._confirmLabel.value = options.confirmLabel;
			this._defaultValue.value = options.defaultValue;
			this._on_save_callback = resolve;
		});
	}
	hide() {
		this._displayed.value = false;
		this.executeOnSaveCallback(null);
	}
}

export const EditorDialogPromptStoreController = EditorDialogPromptStoreControllerClass.instance();
